export default __webpack_public_path__ + "static/media/title.f9293a43.png";